/* global gtag */
/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import store from '../store/store';

Vue.use(Router);

const router = new Router({
  routes,
  mode: 'history',
});

router.beforeEach(async (to, from, next) => {
  const fromPathMeta = from.meta.parentPath;
  const toPathMeta = to.meta.parentPath;
   if(fromPathMeta!== undefined ){
    sessionStorage.setItem('currentRc2FromNav', from.meta.page);
   }
  if(toPathMeta!== undefined ){
    sessionStorage.setItem('currentRc2ToNav', to.meta.page);
  }
 
  if (!to.matched.length) {
    next('/notFound');
  }
  if (from.path === '/') {
    store.dispatch('setStartTime');
  }
  const tokenId = sessionStorage.getItem('accessToken'); // TODO: Detect authenticated session
  const sessionData = sessionStorage.getItem('sessionData'); // TODO: Detect valid custom session data

  // Does this route require authentication?
  if (to.matched.some(record => record.meta.requiresAuth)) {
    
    // if (process.env.IS_OKTA_LOGIN_ENABLED) {
    //   if (!await Vue.prototype.$auth.isAuthenticated()) {
    //     sessionStorage.setItem('callbackUrlSessionItem', to.fullPath);
    //     console.log("callbackUrlSessionItem store here");
    //     next({ path: '/' });
    //   }
    // }
    // if (process.env.IS_OKTA_LOGIN_ENABLED) {
    //   console.log('before each route')
    //   const test=await Vue.prototype.$auth.isAuthenticated();
    //   console.log('under before each route',test);
    //   if (!(await Vue.prototype.$auth.isAuthenticated())) {
    //     // Navigate to custom login page
    //      next({ path: '/LoggedOut' });
    //   }
    // }
    // window.console.info('Scenario 1) Route DOES require auth, so check if logged in.');
    if (!tokenId && !process.env.IS_OKTA_LOGIN_ENABLED) {
      // window.console.info('Scenario 2) Route DOES require auth, and NOT logged in, so go to login.');
      next({ // Route requires auth and is not logged in, so go to login route.
        path: '/',
        query: { redirect: to.fullPath },
      });
    } else {
      /*
      if (process.env.IS_OKTA_LOGIN_ENABLED) {
        if (Vue.prototype.authState && !Vue.prototype.authState.isAuthenticated) {
          await Vue.prototype.$security.beginAuthentication();
        }
      }
      */
      // window.console.info('Scenario 3) Route DOES require auth, and IS logged in, so check session ID.');

      let sessionId = null;

      try {
        sessionId = JSON.parse(sessionData).SessionId; // Get session ID from Session Storage stringified JSON
      } catch (e) {
        /**
         * There was an error in parsing the JSON, so instead of breaking on the error,
         * the fallback rules will be used.
         */
        // window.console.warn('sessionData cannot be parsed, so a \null\' session ID will be used.');
        // window.console.warn(e);
        gtag('event', 'exception', {
          description: 'sessionData cannot be parsed',
          fatal: false, // set to true if the error is fatal
        });
      }

      if (to.matched.some(record => record.meta.requiresSession) && !sessionId) { // TODO: Check for valid session ID
        // window.console.info('Scenario 6) Route requires auth + session ID and is logged in + NO session ID, so go to search.');
        next({ // Route requires auth + session ID and is logged in + NO sessoin ID, so go to search route.
          path: '/search',
          query: { redirect: to.fullPath },
        });
      } else {
        // window.console.info('Scenario 7) Route requires auth +
        // (either has session ID or does not need session ID) and is logged in + (has session ID or does not need session ID), so continue.');
        next(); // Route requires auth + session ID and is logged in + has session ID, so continue.
      }
    }
  } else {
    // window.console.info('Scenario 4) Route does NOT require auth, so coninue.');
    next(); // Route does not require auth, so continue.
  }
});

router.afterEach((to) => {
  /* eslint no-undef: */
  gtag('config', '<%= process.env.GAID %>', { page_path: to.path }); // Add page view to GA

  store.commit('updateAlerts', { // Remove alert
    messages: [],
    variant: '',
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js